import { CenterProps } from "../features/map/types";

interface StateViewConfig {
  center: CenterProps;
  zoom: number;
}

export const stateViewConfigs = new Map<string, StateViewConfig>([
  ["Alabama", { center: [-86.68, 32.67], zoom: 18.4 }],
  ["Alaska", { center: [-153, 62.9], zoom: 2.6 }],
  ["Arizona", { center: [-111.93, 34.3], zoom: 15.2 }],
  ["Arkansas", { center: [-92.5, 34.75], zoom: 22 }],
  ["California", { center: [-119.27, 37.48], zoom: 9.4 }],
  ["Colorado", { center: [-105.55, 39], zoom: 21.2 }],
  ["Connecticut", { center: [-72.76, 41.6], zoom: 60 }],
  ["Delaware", { center: [-75.42, 39.1], zoom: 44 }],
  ["District of Columbia", { center: [-77.01, 38.88], zoom: 300 }],
  ["Florida", { center: [-83.75, 27.80], zoom: 15.5 }],
  ["Georgia", { center: [-83.55, 32.70], zoom: 20 }],
  ["Hawaii", { center: [-157.6, 20.57], zoom: 31 }],
  ["Idaho", { center: [-114.14, 45.6], zoom: 11.0 }],
  ["Illinois", { center: [-89.5, 39.80], zoom: 15.3 }],
  ["Indiana", { center: [-86.44, 39.80], zoom: 21.5 }],
  ["Iowa", { center: [-93.43, 41.98], zoom: 23 }],
  ["Kansas", { center: [-98.36, 38.4], zoom: 19.8 }],
  ["Kentucky", { center: [-85.77, 37.7], zoom: 24.1 }],
  ["Louisiana", { center: [-91.59, 30.95], zoom: 21.8 }],
  ["Maine", { center: [-69.02, 45.3], zoom: 16.6 }],
  ["Maryland", { center: [-77.29, 38.84], zoom: 42 }],
  ["Massachusetts", { center: [-71.72, 42.01], zoom: 44 }],
  ["Michigan", { center: [-86.42, 44.95], zoom: 11.80 }],
  ["Minnesota", { center: [-94, 46.45], zoom: 11.85 }],
  ["Mississippi", { center: [-89.88, 32.62], zoom: 18.0 }],
  ["Missouri", { center: [-92.44, 38.4], zoom: 17.9 }],
  ["Montana", { center: [-110.04, 46.68], zoom: 13 }],
  ["Nebraska", { center: [-99.68, 41.4], zoom: 18 }],
  ["Nevada", { center: [-117.02, 38.65], zoom: 11.45 }],
  ["New Hampshire", { center: [-71.65, 44.02], zoom: 28 }],
  ["New Jersey", { center: [-74.73, 40.12], zoom: 33.8 }],
  ["New Mexico", { center: [-106.03, 34.10], zoom: 13.7 }],
  ["New York", { center: [-75.81, 42.78], zoom: 16.85 }],
  ["North Carolina", { center: [-79.89, 35.15], zoom: 22 }],
  ["North Dakota", { center: [-100.3, 47.25], zoom: 15.3 }],
  ["Ohio", { center: [-82.67, 40.10], zoom: 20.1 }],
  ["Oklahoma", { center: [-98.22, 35.25], zoom: 17.5 }],
  ["Oregon", { center: [-120.51, 43.95], zoom: 15.2 }],
  ["Pennsylvania", { center: [-77.8, 40.85], zoom: 25 }],
  ["Puerto Rico", { center: [-66.58, 18.10], zoom: 63 }],
  ["Rhode Island", { center: [-71.58, 41.60], zoom: 78 }],
  ["South Carolina", { center: [-80.95, 33.55], zoom: 25 }],
  ["South Dakota", { center: [-100.25, 44.05], zoom: 16.0 }],
  ["Tennessee", { center: [-85.99, 35.55], zoom: 23 }],
  ["Texas", { center: [-100.08, 31.25], zoom: 8.9 }],
  ["Utah", { center: [-111.55, 39.35], zoom: 13.6 }],
  ["Vermont", { center: [-72.95, 43.85], zoom: 28 }],
  ["Virginia", { center: [-79.26, 37.93], zoom: 23.2 }],
  ["Washington", { center: [-120.84, 47.25], zoom: 18.6 }],
  ["West Virginia", { center: [-80.18, 38.72], zoom: 20.1 }],
  ["Wisconsin", { center: [-89.85, 44.68], zoom: 15.2 }],
  ["Wyoming", { center: [-107.55, 42.95], zoom: 15.3 }],
]);
